export const Portuguese = [
  {
    "Key": "REGISTER",
    "message": "Registro concluído com sucesso, faça o login em sua conta"
  },
  {
    "Key": "MAILERROR",
    "message": "Digite um e-mail de usuário válido"
  },
  {
    "Key": "ALREADYEXISTS",
    "message": "Usuário já existe"
  },
  {
    "Key": "LOGIN",
    "message": "Conectado com sucesso"
  },
  {
    "Key": "INVALID",
    "message": "Credenciais inválidas"
  },
  {
    "Key": "REQUIRED",
    "message": "Por favor, preencha todos os campos obrigatórios"
  },
  {
    "Key": "PASSWORDSAME",
    "message": "A senha e a confirmação da senha devem ser iguais"
  },
  {
    "Key": "LINKEXPIRED",
    "message": "O link expirou"
  },
  {
    "Key": "NOTFOUND",
    "message": "Usuário não encontrado"
  },
  {
    "Key": "VERIFYERROR",
    "message": "Ocorreu um erro ao verificar se o link expirou"
  },
  {
    "Key": "VERIFYSUCC",
    "message": "Confirmação de conta concluída com sucesso, por favor, faça o login"
  },
  {
    "Key": "VERIFYSUCCESS",
    "message": "O link de ativação da conta expirou, verifique seu e-mail para ativar sua conta"
  },
  {
    "Key": "ALREADYACTIVATED",
    "message": "Conta já ativada"
  },
  {
    "Key": "PENDINGACTI",
    "message": "A verificação da sua conta ainda está pendente, verifique seu e-mail para ativar sua conta"
  },
  {
    "Key": "DEACTIVATED",
    "message": "Sua conta está desativada, entre em contato com a Central de Ajuda"
  },
  {
    "Key": "LOCKED",
    "message": "Sua conta está bloqueada, entre em contato com a Central de Ajuda"
  },
  {
    "Key": "TFALOGIN",
    "message": "Por favor, verifique a autenticação de dois fatores para fazer login"
  },
  {
    "Key": "USERDETAILSERROR",
    "message": "Ocorreu um erro ao buscar detalhes do usuário"
  },
  {
    "Key": "PASSOWORDSERROR",
    "message": "Ocorreu um erro ao alterar sua senha"
  },
  {
    "Key": "PASSOWORDSUCCESS",
    "message": "Sua senha foi alterada com sucesso"
  },
  {
    "Key": "PASSOWORDERROR1",
    "message": "Não foi possível alterar sua senha"
  },
  {
    "Key": "PASSWORDERROR2",
    "message": "Sua senha antiga está incorreta"
  },
  {
    "Key": "FORGOTERROR",
    "message": "Por favor, ative sua conta para esquecer a senha, por favor, ative sua conta e prossiga"
  },
  {
    "Key": "FORGOTERROR1",
    "message": "Não foi possível redefinir sua senha"
  },
  {
    "Key": "RESETFORGOTERR",
    "message": "Ocorreu um erro ao redefinir sua senha"
  },
  {
    "Key": "VERIFYSUC",
    "message": "Verificado com sucesso"
  },
  {
    "Key": "INCORRECT",
    "message": "Senha incorreta"
  },
  {
    "Key": "TFACHECK",
    "message": "Digite o código correto para desativar a autenticação de dois fatores"
  },
  {
    "Key": "TFADISABLE",
    "message": "Autenticação de dois fatores desativada com sucesso"
  },
  {
    "Key": "TFAERR",
    "message": "Não é Possível Desativar a autenticação de dois fatores"
  },
  {
    "Key": "LOGOUTSUC",
    "message": "Saia da sua conta com sucesso"
  },
  {
    "Key": "LOGOUTERR",
    "message": "Não é possível sair da sua conta"
  },
  {
    "Key": "ERRLINKMAIL",
    "message": "Ocorreu um erro durante o email do link do usuário"
  },
  {
    "Key": "LINKMAIL",
    "message": "E-mail de verificação enviado com sucesso"
  },
  {
    "Key": "VERIFYLINKMAIL",
    "message": "Ocorreu um erro ao verificar o email do link do usuário"
  },
  {
    "Key": "GOOGLEERR",
    "message": "Ocorreu um erro durante o login do Google"
  },
  {
    "Key": "FBERR",
    "message": "Ocorreu um erro durante o login no Facebook"
  },
  {
    "Key": "APPLEERR",
    "message": "Ocorreu um erro durante o login da Apple"
  },
  {
    "Key": "IMGERR",
    "message": "Selecione apenas o formato JPG, JPEG, PNG"
  },
  {
    "Key": "IMGERROR",
    "message": "Ocorreu um erro ao atualizar a imagem"
  },
  {
    "Key": "BANKERR",
    "message": "Ocorreu um erro ao atualizar os dados bancários"
  },
  {
    "Key": "BANKALREADY",
    "message": "Banco/UPI já existe"
  },
  {
    "Key": "UPISUCC",
    "message": "UPI adicionado com sucesso"
  },
  {
    "Key": "ERRBANKDATA",
    "message": "Ocorreu um erro enquanto o usuário adicionava detalhes bancários"
  },
  {
    "Key": "MAXLIMITERR",
    "message": "Limite máximo atingido, não é possível adicionar dados bancários"
  },
  {
    "Key": "BANKADDERR",
    "message": "Nenhuma alteração ocorre ao adicionar o banco"
  },
  {
    "Key": "BANKSUCC",
    "message": "Banco adicionado com sucesso"
  },
  {
    "Key": "BANKUPDATEERR",
    "message": "Nenhuma alteração ocorre durante a atualização do banco"
  },
  {
    "Key": "ERRACTIVEBANK",
    "message": "Ocorreu um erro ao alterar o status dos bancos ativos do usuário"
  },
  {
    "Key": "ACTBANKSATATUS",
    "message": "Status do banco ativado com sucesso"
  },
  {
    "Key": "DEAACTBANKSTATUS",
    "message": "Status do banco desativado com sucesso"
  },

  {
    "Key": "ALREADYDEACTIVATED",
    "message": "Status do banco já desativado"
  },
  {
    "Key": "UNABLEEDIT",
    "message": "Não é possível editar este registro já aprovado"
  },
  {
    "Key": "UPDATEBANK",
    "message": "Registro bancário atualizado com sucesso"
  },
  {
    "Key": "NOCHANGE",
    "message": "Nenhuma alteração ocorre durante a atualização dos detalhes do banco/UPI"
  },
  {
    "Key": "ERRUPDATE",
    "message": "Ocorreu um erro ao atualizar os detalhes do banco/UPI"
  },
  {
    "Key": "BANKSTATUSUPDATE",
    "message": "Ocorreu um erro ao alterar o status para atualizar os dados bancários"
  },
  {
    "Key": "NORECORDS",
    "message": "Nenhum registro foi encontrado"
  },
  {
    "Key": "DELETEBANKERR",
    "message": "Ocorreu um erro ao excluir dados bancários"
  },
  {
    "Key": "ADMINREMOVEBANK",
    "message": "Ocorreu um erro ao remover os dados bancários pelo administrador"
  },
  {
    "Key": "AMINREMOVEBANKSUCC",
    "message": "Registro bancário removido pelo administrador com sucesso"
  },
  {
    "Key": "CONSTRAINT",
    "message": "Não foi possível remover os dados bancários, pelo menos um banco deve estar ativo"
  },
  {
    "Key": "GETBANKDATA",
    "message": "Ocorreu um erro ao buscar bancos ativos para usuários"
  },
  {
    "Key": "FETCHERRBANK",
    "message": "Ocorreu um erro ao buscar os dados bancários dos usuários"
  },
  {
    "Key": "LOGINERRACT",
    "message": "Ocorreu um erro ao buscar a atividade do usuário"
  },
  {
    "Key": "CONTACTUSERR",
    "message": "Ocorreu um erro ao enviar a consulta ao administrador"
  },
  {
    "Key": "QUERYREQ",
    "message": "Consulta enviada ao administrador com sucesso"
  },
  {
    "Key": "REMOVEDEVICEERR",
    "message": "Ocorreu um erro ao remover o dispositivo"
  },
  {
    "Key": "REMOVEDEVICE",
    "message": "Dispositivo removido com sucesso"
  },
  {
    "Key": "NOCHANGESUPI",
    "message": "Nenhuma alteração ocorre ao adicionar UPI"
  },
  {
    "Key": "UNABLETOEDIT",
    "message": "Não é possível editar o status do banco, pelo menos um banco deve estar ativo"
  },
  {
    "Key": "CHECKADMINAPPROVAL",
    "message": "Não é possível editar o status do banco antes da aprovação do administrador"
  },
  {
    "Key": "PASSWORDCHECK",
    "message": "A senha antiga e a nova senha não são iguais"
  },
  {
    "Key": "FORGOTSUCC",
    "message": "Esqueci a solicitação de senha enviada com sucesso. Por favor, verifique seu e-mail para prosseguir com o processo"
  },
  {
    "Key": "NOTVERIFIED",
    "message": "Não verificado"
  },
  {
    "Key": "RESETPASSWORD",
    "message": "Senha redefinida com sucesso, faça o login com a nova senha"
  },
  {
    "Key": "TFACODEERR",
    "message": "Insira um código 2FA válido para ativar o 2FA"
  },
  {
    "Key": "TFASUCCESS",
    "message": "2FA ativado com sucesso"
  },
  {
    "Key": "ALREADYTFA",
    "message": "2FA já ativado"
  },
  {
    "Key": "UNABLETFA",
    "message": "Não foi possível ativar o 2FA"
  },
  {
    "Key": "LOGINWITHTFA",
    "message": "2FA foi verificado com sucesso.. Logado com sucesso"
  },
  {
    "Key": "ERRORTFAVERIFY",
    "message": "Ocorreu um erro ao verificar a autenticação de dois fatores durante o login"
  },
  {
    "Key": "MAILVERIFYSUCC",
    "message": "Seu e-mail foi verificado com sucesso"
  },
  {
    "Key": "UPDATEPROFILEERR",
    "message": "Ocorreu um erro ao atualizar o perfil"
  },
  {
    "Key": "NOCHANGEPROFILE",
    "message": "Nenhuma alteração ocorre durante a atualização do perfil"
  },
  {
    "Key": "PROFILESUCC",
    "message": "Perfil atualizado com sucesso"
  },
  {
    "Key": "ERRORKYC",
    "message": "Ocorreu um erro ao atualizar os detalhes de identificação"
  },
  {
    "Key": "KYCUPDATEERR",
    "message": "Não foi possível atualizar seus detalhes de identificação"
  },
  {
    "Key": "KYCREUPLOAD",
    "message": "Reenvio de detalhes de identificação com sucesso"
  },
  {
    "Key": "REUPLOADKYCCHANGE",
    "message": "Nenhuma alteração ocorre durante o reupload de detalhes de identificação"
  },
  {
    "Key": "KYCSUCC",
    "message": "Seus documentos de identificação foram enviados com sucesso"
  },
  {
    "Key": "ALREADYKYC",
    "message": "Seu documento de identifcação já foi aprovado"
  },
  {
    "Key": "HISTORYDEPOSIT",
    "message": "Ocorreu um erro ao buscar o histórico de depósitos dos usuários"
  },
  {
    "Key": "HISTORYWITHDRAW",
    "message": "Ocorreu um erro ao buscar o histórico de saque dos usuários"
  },
  {
    "Key": "SINGLEHISTORY",
    "message": "Ocorreu um erro ao buscar o histórico de saques ou depósitos do usuário"
  },
  {
    "Key": "HOLDBALANCEERR",
    "message": "Ocorreu um erro ao buscar o saldo do usuário junto com o saldo em espera"
  },
  {
    "Key": "TRANSHISERR",
    "message": "Ocorreu um erro ao buscar o histórico de transações do usuário"
  },
  {
    "Key": "KYCCHECKERR",
    "message": "Conclua o processo de Identificação para continuar o depósito"
  },
  {
    "Key": "AMOUNTZERO",
    "message": "O valor deve ser maior que 0"
  },
  {
    "Key": "DEPOSITERR",
    "message": "Ocorreu um erro durante a solicitação de depósito do usuário"
  },
  {
    "Key": "DEPOSITSUCBYBANK",
    "message": "Solicitação de depósito pelo banco enviada ao administrador com sucesso"
  },
  {
    "Key": "DEPOSITSUCBYUPI",
    "message": "Solicitação de depósito por UPI enviada ao administrador com sucesso"
  },
  {
    "Key": "MINDEPOSIT",
    "message": "Você pode fazer um depósito mínimo de"
  },
  {
    "Key": "MAXDEPOSIT",
    "message": "Você pode fazer um depósito máximo de"
  },
  {
    "Key": "DEPOSITADMINAPPROVE",
    "message": "Depósito permitido somente após aprovação do administrador, por favor, tente com outro banco"
  },
  {
    "Key": "DEPOSITADMINREJECT",
    "message": "Solicitação de depósito em conta rejeitada pelo administrador, tente com outro banco"
  },
  {
    "Key": "DEPOSITBANKVAL",
    "message": "Por favor, ative os dados bancários para efetuar o depósito"
  },
  {
    "Key": "WITHDRAW2FACHECK",
    "message": "Habilitar 2FA para prosseguir com o processo de saque"
  },
  {
    "Key": "WITHDRAWKYCCHECK",
    "message": "Conclua o processo de identificação para prosseguir com o processo de saque"
  },
  {
    "Key": "WITHDRAWKYCTFA",
    "message": "Conclua o processo de identificação e ative o 2FA para prosseguir com o processo de saque"
  },
  {
    "Key": "MINWITHDRAW",
    "message": "Você pode fazer uma saque mínima de"
  },
  {
    "Key": "MAXWITHDRAW",
    "message": "Você pode fazer uma saque máxima de"
  },
  {
    "Key": "WITHDRAWFEEGREATER",
    "message": "Insira um valor maior que a taxa de saque"
  },
  {
    "Key": "INSUFFICIENTFUNDS",
    "message": "Fundos insuficientes"
  },
  {
    "Key": "WITHDRAWERR",
    "message": "Ocorreu um erro ao enviar a solicitação de saque"
  },
  {
    "Key": "WITHDRAWSUCC",
    "message": "Um e-mail de confirmação de saque foi enviado para o seu e-mail com sucesso, verifique sua caixa de mensagem para aprovar"
  },
  {
    "Key": "FAILWITHDRAW",
    "message": "Solicitação de Saque Falhou"
  },
  {
    "Key": "WITHDRAWLINK",
    "message": "O link de verificação de saque expirou, verifique seu e-mail para prosseguir com a solicitação de saque"
  },
  {
    "Key": "WITHDRAWANOTHER",
    "message": "Por favor, inicie outra solicitação de saque para prosseguir com a sua solicitação"
  },
  {
    "Key": "USERCONFIRMERROR",
    "message": "Ocorreu um erro enquanto o usuário confirmava a solicitação de saque aprovada"
  },
  {
    "Key": "USERCONFIRMWITHDRAW",
    "message": "Solicitação de saque enviada com sucesso ao administrador"
  },
  {
    "Key": "WITHDRAWUSERREJECT",
    "message": "Ocorreu um erro enquanto o usuário confirmava o cancelamento da solicitação de saque"
  },
  {
    "Key": "WITHDRAWCONFIRMREJECT",
    "message": "Ocorreu um erro enquanto o usuário confirma/cancela a solicitação de saque"
  },
  {
    "Key": "WITHDRAWACANCEL",
    "message": "Solicitação de saque cancelada pelo usuário"
  },
  {
    "Key": "WITHDRAWCANCELLEDUSER",
    "message": "Solicitação de saque já cancelada pelo usuário"
  },
  {
    "Key": "WITHDRAWINPROGRESS",
    "message": "Solicitação de saque já em andamento"
  },
  {
    "Key": "ADMINAPPROVEORREJECT",
    "message": "Ocorreu um erro ao aprovar ou rejeitar o depósito do usuário"
  },
  {
    "Key": "ADMINAPPROVEDEPOSIT",
    "message": "Ocorreu um erro ao aprovar a solicitação de depósito do usuário"
  },
  {
    "Key": "ADMINAPPORVEDEPOSIT",
    "message": "Solicitação de depósito aprovada pelo administrador com sucesso"
  },
  {
    "Key": "ADMINDEPOSITCOMPLETED",
    "message": "Solicitação de depósito já concluída"
  },
  {
    "Key": "DEPOSITERRUSER",
    "message": "Ocorreu um erro ao rejeitar a solicitação de depósito do usuário"
  },
  {
    "Key": "DEPOSITREJ",
    "message": "Solicitação de depósito rejeitada pelo administrador"
  },
  {
    "Key": "DEPOSITREJALREADY",
    "message": "Solicitação de depósito já rejeitada"
  },
  {
    "Key": "ADMINCANCELWITHDRAW",
    "message": "Solicitação de saque cancelada pelo administrador"
  },
  {
    "Key": "WITHDRAWCOMPLETED",
    "message": "Solicitação de saque já concluída"
  },
  {
    "Key": "APPROVEREJECTWITHDRAW",
    "message": "Ocorreu um erro ao aprovar ou rejeitar a saque do usuário"
  },
  {
    "Key": "USERCANCELWITHDRAW",
    "message": "Ocorreu um erro ao cancelar a solicitação de saque do usuário"
  },
  {
    "Key": "HOLDAMOUNT0",
    "message": "O valor da retenção do usuário é 0. Solicitação de saque cancelada pelo administrador com sucesso"
  },
  {
    "Key": "WITHDRAWADMIN",
    "message": "Solicitação de saque aprovada pelo administrador com sucesso"
  },
  {
    "Key": "WITHDRAWAPPROVERR",
    "message": "Ocorreu um erro ao aprovar a solicitação de saque do usuário"
  },
  {
    "Key": "USERCANTPROCEED",
    "message": "O usuário não pode confirmar ou cancelar a solicitação de saque"
  },
  {
    "Key": "DEPOSITALREADY",
    "message": "Solicitação de depósito já concluída"
  },
  {
    "Key": "DEPOSITCANCELLED",
    "message": "Solicitação de depósito já cancelada"
  },
  {
    "Key": "SITERR",
    "message": "Ocorreu um erro ao buscar as configurações do site"
  },
  {
    "Key": "CMSERR",
    "message": "Ocorreu um erro ao buscar o CMS"
  },
  {
    "Key": "USERSTATERR",
    "message": "Ocorreu um erro ao buscar estatísticas de usuário único por jogo"
  },
  {
    "Key": "USERALLGAMESTAT",
    "message": "Ocorreu um erro ao buscar estatísticas gerais de um único usuário"
  },
  {
    "Key": "GAMEERR",
    "message": "Ocorreu um erro ao buscar o histórico de jogos de um único usuário"
  },
  {
    "Key": "COMMONGAMEERR",
    "message": "Ocorreu um erro ao buscar o histórico do jogo"
  },
  {
    "Key": "CRASHGAMEPHASE",
    "message": "Aguarde a fase do jogo.."
  },
  {
    "Key": "NOACTIVEUSER",
    "message": "Não é um usuário ativo"
  },
  {
    "Key": "CRASHRESULTUPD",
    "message": "Resultados de falha já concluídos"
  },
  {
    "Key": "WONGAME",
    "message": "você ganhou!"
  },
  {
    "Key": "LOSSGAME",
    "message": "Opa..!! você está perdido"
  },
  {
    "Key": "CRASHERR",
    "message": "Ocorreu um erro ao atualizar os resultados do travamento"
  },
  {
    "Key": "BETERR",
    "message": "Ocorreu um erro ao buscar a aposta atual"
  },
  {
    "Key": "ISNAN",
    "message": "Digite um número válido.."
  },
  {
    "Key": "INSUFFICIENT",
    "message": "Saldo insuficiente para apostar"
  },
  {
    "Key": "BETHASE",
    "message": "Aguarde a fase de apostas.."
  },
  {
    "Key": "BET",
    "message": "Aposta colocada com sucesso"
  },
  {
    "Key": "MINESERR",
    "message": "Ocorreu um erro ao atualizar os resultados do Mines"
  },
  {
    "Key": "MINESUPDATE",
    "message": "Resultados da mina já concluídos"
  },
  {
    "Key": "HITIDERR",
    "message": "O ID da ocorrência deve ser menor que a contagem de ocorrências"
  },
  {
    "Key": "BETCREATEERR",
    "message": "Ocorreu um erro ao criar a aposta"
  },
  {
    "Key": "CURRERR",
    "message": "Ocorreu um erro ao buscar uma única moeda"
  },
  {
    "Key": "CREATE_PAYMENT",
    "message": "Pagamento criado com sucesso"
  },
  {
    "Key": "PAYMENT_ERR",
    "message": "Create payment error"
  },
  {
    "Key": 'WITHDRAWREQ', 'message': "Solicitação máxima de retirada atingida"
  },
  {
    Key: "INVALIDCOUNT", message: "Contagem de diamantes inválida"
  },
  {
    Key: "BLOCKEDUSER", message: "Incapaz de entrar"
  },


  {
    Key: "ALREADYACTIVATED", message: "Conta já ativada"
  },
  {
    Key: "MAILRESENT", message: "Verifique seu e-mail para ativar a conta"
  },
  {
    Key: "ALREADYACTIVATED", message: "Conta já ativada"
  },

  {
    Key: "MAILACTIVATED", message: "Confirmação de conta concluída com sucesso, por favor, faça o login",
  },
  {
    Key: "EMAILERR", message: "Ocorreu um erro ao enviar e - mail"
  },
  {
    Key: "NOCHANGECPF", message: "Nenhuma alteração ocorre durante a atualização do CPF",
  },
  {
    Key: "CPFSUCC", message: "CPF atualizado com sucesso"
  },
  {
    Key: "CPFALREADY", message: "CPF já atualizado",
  },

  // Confirmação de conta concluída com sucesso, por favor, faça o login
]